import { atom } from 'jotai';
import type { GetAllProductsResponse } from '@models/product';

export const productsAtom = atom<GetAllProductsResponse>({
    items: [],
    pageNumber: 1,
    totalPages: 0,
    count: 0,
    hasPreviousPage: false,
    hasNextPage: false,
});

export const isFetchingProductsAtom = atom<boolean>(false);

// GET /products/{id} publishes to no atom. Its callers (the product page, the admin edit page)
// keep the read's outcome in their own state (#407): an app-scoped flag outlived the page and
// painted the previous visit's, or the previous product's, failure.

export const isProcessingProductsAtom = atom<boolean>(false);
